<template>
  <el-table :data="list" style="width: 100%; padding-top: 15px">
    <el-table-column label="Order_No">
      <template slot-scope="scope">
        {{ scope.row.order_no | orderNoFilter }}
      </template>
    </el-table-column>
    <el-table-column label="Price" align="center">
      <template slot-scope="scope">
        ¥{{ scope.row.price | toThousandFilter }}
      </template>
    </el-table-column>
    <el-table-column label="Status" width="100" align="center">
      <template slot-scope="{ row }">
        <el-tag :type="row.status | statusFilter">
          {{ row.status }}
        </el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { transactionList } from '@/api/remote-search'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        success: 'success',
        pending: 'danger'
      }
      return statusMap[status]
    },
    orderNoFilter(str) {
      return str.substring(0, 30)
    }
  },
  data() {
    return {
      list: [
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'success'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'success'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'pending'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'pending'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'success'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'pending'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'success'
        },
        {
          order_no: 'F6995Efb-FFCB-6be6-Bf84-aB6EbF',
          price: '5180',
          status: 'pending'
        }
      ]
    }
  }
}
</script>
